<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { QuotedMessageResultDTO } from '@nora-monorepo/nora-api-client';
import { formatName } from '@nora-monorepo/shared';
import {
  bgFillQuaternary,
  textSecondary,
} from '@nora-monorepo/ui-shared';

interface MessageReplyProps {
  message: QuotedMessageResultDTO;
  mine: boolean;
}

defineProps<MessageReplyProps>();
const { t } = useI18n();
</script>

<template>
  <div
    class="mb-1 p-1 rounded-sm text-xs"
    :class="[
      bgFillQuaternary,
      mine ? 'text-label-on-accent-secondary' : textSecondary,
    ]"
  >
    <div class="w-full font-semibold">
      <span class="mi reply md-16 mr-1 align-text-bottom leading-5" />
      <span>
        {{ t('message.repliedTo') }}
        {{ formatName(message.sentBy) }}
      </span>
    </div>
    <div v-if="message.attachmentsCount">
      <span class="mi attach_file md-16 mr-2" /><span>{{ message.attachmentsCount }} Attachments</span>
    </div>
    <div v-if="message.deletedAt">
      <span class="mi delete mt-1 md-16 mr-0" />
      <span>{{ t('message.deleted') }}</span>
    </div>
    <div v-else class="line-clamp-2">
      {{ message.message }}
    </div>
  </div>
</template>
